export default __webpack_public_path__ + "static/media/download.d928c3b6.svg";